import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

// Social
import Facebook from '~components/Svg/Facebook';
import Twitter from '~components/Svg/Twitter';

// Icons
import Envelope from '~components/Svg/Envelope';
import Globe from '~components/Svg/Globe';
import Map from '~components/Svg/Map';
import Phone from '~components/Svg/Phone';

import useSiteMetaData from '~hooks/useSiteMetaData';
import { ExternalLink } from '~components/Link';

const Footer: React.FC = () => {
  const { siteMetadata } = useSiteMetaData();
  return (
    <footer tw="mt-12">
      <div tw="flex flex-row justify-center items-center space-x-24 space-y-0 md:(space-y-0)">
        <a tw="text-xl font-bold flex items-center space-x-2 hover:(underline)" href="https://www.facebook.com/TheNeighbourhoodGroup/">
          <Facebook tw="w-14 h-14" />
          <span>Facebook</span>
        </a>
        <a tw="text-xl font-bold flex items-center space-x-2 hover:(underline)" href="https://twitter.com/NeighbourhdGrp">
          <Twitter tw="w-14 h-14" />
          <span>Twitter</span>
        </a>
      </div>
      <div tw="bg-gray-100 py-24 my-12">
        <div tw="container">
          <div tw="grid gap-12 mb-24 md:(grid-cols-2)">
            <a
              href="https://theneighbourhoodgroup.akaraisin.com/ui/tngcsdonations/donations/start"
              tw="block rounded-lg py-4 px-6 text-lg font-bold text-white bg-blue text-center hover:(bg-blue-700) focus:(outline-none ring-4 ring-blue ring-opacity-60)"
            >
              Donate Now
            </a>
            <a
              href="https://www.theneighbourhoodgroup.org/"
              tw="block rounded-lg py-4 px-6 text-lg font-bold text-green-900 bg-green text-center hover:(bg-green-800 text-green-50) focus:(outline-none ring-4 ring-green ring-opacity-60)"
            >
              View Our Main Site
            </a>
          </div>
          <div tw="grid gap-12 grid-cols-2 lg:(grid-cols-4)">
            <div tw="flex flex-col space-y-2">
              <Map tw="w-20 h-20 text-blue" />
              <p tw="font-bold text-xl">Address</p>
              <p tw="text-lg">349 Ontario St., Toronto, ON M5A 2V8</p>
            </div>
            <div tw="flex flex-col space-y-2">
              <Phone tw="w-20 h-20 text-blue" />
              <p tw="font-bold text-xl">Phone</p>
              <p tw="text-lg">
                <a tw="text-blue underline hover:no-underline" href="tel:+14169254363">
                <strong>416.925.4363</strong>
                </a>
              </p>
            </div>
            <div tw="flex flex-col space-y-2">
              <Envelope tw="w-20 h-20 text-blue" />
              <p tw="font-bold text-xl">Email</p>
              <p tw="text-lg">
                <a tw="text-blue underline hover:no-underline" href="mailto:info@tngcs.org">
                  <strong>info@tngcs.org</strong>
                </a>
              </p>
            </div>
            <div tw="flex flex-col space-y-2">
              <Globe tw="w-20 h-20 text-blue" />
              <p tw="font-bold text-xl">Website</p>
              <p tw="text-lg">
                  <ExternalLink to="https://www.theneighbourhoodgroup.org">Visit Website</ExternalLink>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div tw="container my-6 md:my-6">
        <div tw="flex flex-col items-center space-y-6">
          <div tw="flex flex-row space-x-12 space-y-6 md:(space-y-0 space-x-32) items-start">
            <div tw="w-24 h-auto"><StaticImage src="../../images/carf.png" alt="CARF" /></div>
            <div tw="w-56 h-auto"><StaticImage src="../../images/united-way.png" alt="United Way" /></div>
          </div>
          <div>
            <p tw="text-sm text-center my-1">
              &copy;2021, The Neighbourhood Group, Report by{' '}
              <a tw="text-blue hover:underline" href="https://floating-point.com">
                floating-point
              </a>
            </p>
            <p tw="text-sm text-center my-1">Charitable Registration Number: 89132 3164 RR0001</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
